import styles from './MooMooBanner.module.scss';
import { track } from '@amplitude/analytics-browser';
import classNames from 'classnames';
import { useRouter } from 'next/router';

const randomBgUrl = () => {
  return '/images/banners/takatrade-opening-0925.jpg';
};

const TakaTradeBanner = ({
  fallbackElement,
  className,
}: {
  fallbackElement?: JSX.Element;
  className?: string;
}) => {
  const bgUrl = randomBgUrl();
  const router = useRouter();
  if (!bgUrl) return fallbackElement ? fallbackElement : <></>;
  return (
    <div
      className={classNames(styles.banner, className ?? '')}
      onClick={() => {
        track('Click Top Banner', { banner_type: 'takatrade_banner' });
        void router.push('/lp/takatrade-opening');
      }}
    >
      <img src={bgUrl} width="100%" />
    </div>
  );
};

export default TakaTradeBanner;
